const extractBeforeDash = (input: string): string => {
	const index = input.indexOf('-');
	if (index !== -1) {
		return input.substring(0, index).toUpperCase();
	}
	return input;
};

export default extractBeforeDash;
